import { ICardElementWithChildren } from "backend/model/model";
import { t } from "i18next";
import React from "react";
import { useAppContext } from "../../qpr-base/context/AppCtxProvider";
import { makeThemedStyles } from "../../qpr-base/viewcomponents/utils";
import SubElementHeader from "./SubElementHeader";

interface Props {
  handleCalculator: () => any;
  updateResult: (val: any) => any;
  isDisabled: boolean;
  elements: ICardElementWithChildren[];
}
const useStyles = (rtl: boolean) =>
  makeThemedStyles("", (theme) => ({
    elementsContainer: {
      width: "100%",
    },
    elementContainer: {
      marginBottom: "8px",
    },
    valueHeader: {
      fontFamily: "Dubai",
      fontStyle: "normal",
      fontWeight: 400,
      width: "100%",
      fontSize: "1.828em",
      lineHeight: "1.25em",
      color: "rgb(76, 81, 87)",
      marginBottom: "0.5em",
      paddingLeft: "1.5em",
      paddingRight: "1.5em",
      visibility: "hidden",
    },
    valueTable: {
      overflow: "hidden",
      width: "100%",
      margin: "-3.2em 2.85em 0.68em 0",
      border: "0.11em solid rgb(209, 213, 219)",
      borderRadius: "1.1em",
    },
  }));
const SubElements = (props: Props) => {
  const ctx = useAppContext();
  const classes = useStyles(ctx.rtl)();
  const { isDisabled, updateResult } = props;
  return (
    <div className={classes.elementsContainer}>
      <div className={classes.valueHeader}>{t("kpis.Sub Elements")}</div>
      <div className={classes.valueTable}>
        {props.elements.map((ele, index) => {
          return (
            <div className={classes.elementContainer}>
              <SubElementHeader
                isDisabled={isDisabled !== undefined ? isDisabled : true}
                element={ele}
                elementIndex={index}
                key={index}
                handleFieldElement={updateResult}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default SubElements;
